import { Button, Icon, Title } from '@gerdau/hefesto';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { allQuestionAnswer } from '../../../components/QuestionsAnswers/helpCenterQuestions';
import { ERoutes } from '../../../routes';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../utils/Tagging';
import { EHelpCenterRoutes } from '../helpCenter.routes';
import { Container } from './styles';

export const CommonQuestions: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const { screenName = '' } = getTaggingInformationScreen(pathname, true);

  useEffect(() => {
    dispatch(
      sendTagging({
        event: 'page_view',
        screenName,
        page: pathname
      })
    );
  }, []);

  const getButtons = () => {
    return allQuestionAnswer.map((questionAnswer) => (
      <Button
        key={questionAnswer.route}
        name={questionAnswer.title}
        variant={'tertiary'}
        icon={<Icon option="ChevronRight" />}
        iconPosition={'right'}
        fullWidth
        onClick={() => {
          dispatch(
            sendTagging({
              event: 'click',
              screenName,
              itemName: questionAnswer.tagItemName,
              itemDescription: questionAnswer.tagItemDescription
            })
          );
          history.push(
            `${ERoutes.HELP_CENTER}${EHelpCenterRoutes.COMMON_QUESTIONS}${questionAnswer.route}`
          );
        }}
      >
        {questionAnswer.title}
      </Button>
    ));
  };

  return (
    <Container>
      <Title level={2}>Perguntas frequentes</Title>
      <p>
        Pensando na melhor experiência para você, criamos esse canal para que
        você possa tirar as dúvidas mais comuns com mais facilidade e agilidade.
      </p>

      {getButtons()}
    </Container>
  );
};
